import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-20 md:py-28 bg-background-900">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-12">
          热门话题
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className={`group flex flex-col items-center justify-center p-5 md:p-7 rounded-2xl transition-all duration-300 cursor-pointer ${
                topic.trending
                  ? 'bg-accent-500/10 border border-accent-500/30 hover:bg-accent-500/20'
                  : 'bg-background-800 border border-white/5 hover:bg-background-700'
              }`}
            >
              <div className="flex items-center gap-2 mb-1.5">
                {topic.trending && <i className="ri-fire-line text-accent-500 text-sm"></i>}
                <span className={`font-semibold text-sm md:text-base ${topic.trending ? 'text-accent-400' : 'text-white/80'}`}>
                  {topic.name}
                </span>
              </div>
              <span className={`text-xs ${topic.trending ? 'text-accent-500/60' : 'text-white/30'}`}>
                {topic.hot} 热度
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}